require("jquery");

require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/modal');

const Swiper = require('../../node_modules/swiper/dist/js/swiper.js');
//const Barba = require('../../node_modules/barba.js/dist/barba.js');
const mixitup = require('../../node_modules/mixitup/dist/mixitup.js');

$(function () {

    initPagePlugins();

    function initPagePlugins() {

        /**
         * Mix it up
         */
        if($('.filter-container').length > 0) {

            var mixer = mixitup('.filter-container', {
                selectors: {
                    target: '.mix'
                },
                animation: {
                    duration: 0
                }
            });

        }

        /**
         * Init BS Dropdown
         * http://getbootstrap.com/docs/4.0/components/dropdowns/
         *
         */
        $('.dropdown-toggle').dropdown();

        $('.scroll-to[href^="#"]').on('click', function(e){
            var href = $(this).attr('href');
            var nav = $('.js-primary-nav').outerHeight();

            $('html, body').animate({
                scrollTop:$(href).offset().top - nav
            },'slow');

            e.preventDefault();
        });

        /**
         * Swiper Slider
         * https://github.com/nolimits4web/Swiper
         *
         */
        $('.swiper-gallery').each(function (index, element) {
            $(this).addClass('swiper-' + index);
            $(this).find('.swiper-pagination').addClass('swiper-pagination-' + index);
            //$(this).find('.swiper-button-prev').addClass('swiper-prev-' + index);
            //$(this).find('.swiper-button-next').addClass('swiper-next-' + index);

            var mySwiper = new Swiper('.swiper-' + index, {
                speed: 600,
                effect: 'slide',
                loop: true,
                spaceBetween: 0,
                simulateTouch: true,
                noSwiping: false,
                observer: true,
                pagination: {
                    el: '.swiper-pagination-' + index,
                    type: 'bullets',
                    clickable: true
                },
                // Navigation arrows
                /*navigation: {
                    nextEl: '.swiper-next-' + index,
                    prevEl: '.swiper-prev-' + index,
                },*/
                preloadImages: false,
                lazy: true,
                lazyLoadingInPrevNext: true,
                loadPrevNextAmount: 2
            });

        });


        var myFilter = new Swiper('.swiper-filter', {
            freeMode: true,
            freeModeSticky: true,
            freeModeMomentumBounce: false,
            freeModeMomentumRatio: 0.5,
            freeModeMomentumBounceRatio: 0.5,

            slidesPerView: 'auto',
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                hide: true
            },
        });

    }

});


// WEBPACK FOOTER //
// ./_assets/js/basics.js